module.exports = __webpack_public_path__ + "static/media/order.5fc23339.svg";